import type { ProductFormulation } from '@/constants/products';
import { FORMULATION_FILTER_ID, isProductFormulation } from '@/constants/products';
import type { Filters } from '@/shared-ui/ProductFilter/ProductFilter';

/** The formulation a pad item was filtered by, e.g. 'Herb, Dried'; undefined before one is chosen or when unknown. */
export const getFormulationFilter = (filters: Filters | undefined): ProductFormulation | undefined => {
  const value = filters?.get(FORMULATION_FILTER_ID);
  return value !== undefined && isProductFormulation(value) ? value : undefined;
};
